import config from 'config';

/**
 * Returns the tag ID used to identify products with hidden behavior.
 * This tag is used to filter out certain products from grids and results.
 */
const getTailgateHiddenBehaviorTagId = (): number | undefined => {
  return config.get('public.productTags.hiddenBehavior') as number | undefined;
};

export default getTailgateHiddenBehaviorTagId;
